import $ from 'jquery';
import 'jquery.inputmask';
import 'inputmask.numeric.extensions';
import popper from 'popper.js';
import bootstrap from 'bootstrap';
import 'slick-carousel';

// product slider on product page
$('.main_slider').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  fade: true,
  asNavFor: '.nav_slider'
});

$('.nav_slider').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  asNavFor: '.main_slider',
  dots: true,
  centerMode: true,
  focusOnSelect: true
});

$('.checkout_products_slider').slick({
  dots: false,
  arrows: true,
  prevArrow: "",
  nextArrow: "<button class='myslick_nextbtn'>Следующий товар <img src='img/arrow_right.png' class='img-fluid' alt='icon'></button>"
});

$('.pr_landing_slider').slick({
  dots: false,
  arrows: false
});

$('.review_slider').slick({
  slidesToShow: 5,
  slidesToScroll: 1,
  dots: false,
  arrows: false,
  responsive: [
                            {
                              breakpoint: 768,
                              settings: {
                                slidesToShow: 4,
                                slidesToScroll: 1
                              }
                            },
                            {
                              breakpoint: 576,
                              settings: {
                                slidesToShow: 2,
                                slidesToScroll: 1
                              }
                            }
                          ]
});

$('.checkout_products_slider .controls a').slick();

$('.menu_btn').click(function () {
  $('.mobile_menu').addClass('mobile_menu_active');
});

$('.close_btn').click(function () {
  $('.mobile_menu').removeClass('mobile_menu_active');
});

$('.mobile_menu a').click(function () {
  $('.mobile_menu').removeClass('mobile_menu_active');
});

// footer rotate icons
$("footer .card").click(function () {
  $("footer .card").find('.links_block_name').find('img').removeClass('rotate_img');
  $(this).find('.links_block_name').find('img').addClass('rotate_img');
});

// functions for count of products in the cart
function add(q) {
  var count = q.parent().find('.count').text();
  count++;
  q.parent().find('.count').text(count);
}

function substract(q) {
  var count = q.parent().find('.count').text();
  if (count > 0) {
    count--;
    q.parent().find('.count').text(count);
  }
}

$('.counter .counter_btn').click(function () {
  if ($(this).hasClass('plus_btn')) {
    add($(this));
  }
  else {
    substract($(this));
  }
});

$('.delete_wrap a').click(function () {
  $(this).closest('.item_line').hide();
});

// Функция по клику на название категории на странице товара
$('.categories_name a').click(function () {

  // add/remove class for categories name on product page on pc
  $('.categories_name a').removeClass('active');
  $(this).addClass('active');

  // Переключение контента
  var block_name = $(this).attr('data-name');
  $('.categories_content').hide();
  $('#' + block_name).show();
});

// add/remove class for categories name on product page on mobile
$('.categories_name .card').click(function () {
  $('.categories_name .card').removeClass('active_card');
  $(this).addClass('active_card');
});

// Переключение на странице cabinet
$('.cabinet_block .row_pc a').click(function () {
  // add/remove class for categories name on product page on pc
  $('.cabinet_block .row_pc a').removeClass('active_block');
  $(this).addClass('active_block');

  // Переключение контента
  var block_name = $(this).attr('data-name');
  $('.hide_this_block').hide();
  $('.' + block_name).show();
});


// маска номера
$(".maskphone").inputmask({ "mask": "+38 (099) 999-9999" });

$('.hide_this_block').hide();
$('.contact_info_block').show();

// для категорий на странице продукта
$('.categories_content').hide();
$('#description_block').show();

// для звезд рейтинга
if ($(window).width() <= '992') {
  $('.stars_rating label').text('');
}

// скрыть фильтры при загрузке страницы
$('.filters_block_for_catalog .item_wrap .item_body').hide();

// скрыть вывод выбранных фильтров
$(".item_body_item .link_wrap").hide();

// SEARCH скрыть результаты
$('.search_modal .search_results').hide();

// Скрыть табы в Checkout.html
$('.steps_block .step .step_body .tab .tabs_body_wrap .show_tab').hide();
$('.steps_block .step .step_body .tab .tabs_body_wrap .show_tab1').show();

// Скрыть форму редактирования на телефонах
$("#delivery_address .block .form_wrap").hide();


// Для видео
// $(".youtube_videoblock .video_wrap button").click(function (e) {
//   e.preventDefault();
//   var poster = $(this);
//   var wrapper = poster.closest('.video_wrap');
//   videoPlay(wrapper);
// });
$(".custom_play_btn").click(function (e) {
  e.preventDefault();
  var poster = $(this);
  var wrapper = poster.parent('.video_wrap');
  videoPlay(wrapper);
});

$("#about_heading3").click(function (e) {
  var poster = $(this).parent().find('#about_menu3 .video_wrap button');
  var wrapper = poster.closest('.video_wrap');
  videoPlay(wrapper);
});

// вопроизводим видео, при этом скрывая постер
function videoPlay(wrapper) {
  var iframe = wrapper.find('iframe');
  var src = iframe.data('src');
  wrapper.find('button').addClass('hidden_videoposter');
  iframe.attr('src', src);
}

// Звезды
$('.stars_rating label').click(function () {
  $(this).prev().prop({ 'checked': true });
});

// скрытие блока фильтра на странице catalog.html
$('.show_item_body_btn').click(function () {
  let block = $('.filters_block_for_catalog .item_wrap .item_body');
  if (block.is(':visible')) {
    $(this).html("Показать");
    block.fadeOut(200);
  }
  else {
    $(this).html("<img src='img/close_icon_blue.png' class='img-fluid' alt='icon'> Скрыть");
    block.fadeIn(200);
  }
});

// Функционал фильтров
$('.checkbox_type').change(function(){
  if($(this).hasClass('disabled')){
    return false;
  }
  else {
    add_value($(this), $(this).parent().parent().siblings("a")[0].id);
  }
});

function add_value(e, id){
  let val = e.find('input').val();
  $("." + id).html(val); // добавляем новое выбранное
  $(".item_body_item .link_wrap_" + id).show(); // показываем строку со значениями
};

// клик на крестик в строке с фильтрами
$('.hide_checkbox_values').click(function () {
  $(this).parent().hide();
});

// SEARCH
$('.search_modal form input[type="search"]').keydown(function () {
  $('.search_modal .search_results').fadeIn(200);
});

// checkout page
$('.tab .tabs_heading_wrap .tab').click(function () {
  $('.tab .tabs_heading_wrap .tab').removeClass('active_tab');
  $(this).addClass('active_tab');
  $(this).parent().closest('.tab').find('.show_tab').hide();
  let id = $(this).attr('id');
  $(this).parent().closest('.tab').find('.tabs_body_wrap').find('.' + id).show();

  if ($(window).width() >= '1199') {
    if ($(this).parent().closest('.tab').find('.tabs_body_wrap').find('.show_tab2').is(':visible')) {
      $('.checkout .steps_block .step .step_body .tab .tabs_body_wrap form').css('width', '130%');
    }
    else {
      $('.checkout .steps_block .step .step_body .tab .tabs_body_wrap form').css('width', 'calc(100% + 15px)');
    }
  }
});

// Для фильтров на product.html
$('.product_info .right_block .filters_block .filter .links span').click(function () {
  if ($(this).hasClass('disable')) {
    return false;
  }
  else {
    $(this).toggleClass('active');
  }
});

// Для фильтров на product.html
$('.product_info .right_block .filters_block .color_filter .colors .wrap').click(function () {
  $('.product_info .right_block .filters_block .color_filter .colors .wrap').removeClass('active');
  $(this).toggleClass('active');
});

// Для фильтров на product-landing.html
$('.pr_landing_top_section .left_item .filters_block .color_filter .colors .wrap').click(function () {
  $('.pr_landing_top_section .left_item .filters_block .color_filter .colors .wrap').removeClass('active');
  $(this).toggleClass('active');
});

$('.pr_landing_top_section .left_item .filters_block .filter .links span').click(function () {
  if ($(this).hasClass('disable')) {
    return false;
  }
  else {
    $(this).toggleClass('active');
  }
});

// cabinet page
$("#delivery_address .block .edit_orange_link").click(function () {
  $(this).closest('.block').find('.form_wrap').show();
});

// Замена + на - при клике на карточку на мобильном
$('.cabinet_block .row_mob #mylcaccordion .card .card-header').click(function () {
  if ($(this).parent().find('.lc_menu').hasClass('show')) {
    $(this).find('.links_block_name').find('span').text('+');
  }
  else {
    $(this).find('.links_block_name').find('span').text('-');
  }
});
//-----------------------------------------------------------------------
//--------------------------timer----------------------------------------
//-----------------------------------------------------------------------
function init(elem, options) {

  elem.addClass('countdownHolder');
  // Создание HTML разметки внутри контейнера
  $.each(['Days', 'Hours', 'Minutes', 'Seconds'], function (i) {
    $('<span class="count' + this + '">').html(
      '<span class="position update_position">\
                        <span class="digit static">0</span>\
                </span>\
                <span class="position">\
                        <span class="digit static">0</span>\
                </span>'
    ).appendTo(elem);
    if (this != "Seconds") {
      elem.append('<span class="countDiv countDiv' + i + '"></span>');
    }
  });
}
// Создает анимационный эффект между двумя цифрами таймера
function switchDigit(position, number) {
  var digit = position.find('.digit')
  if (digit.is(':animated')) {
    return false;
  }
  if (position.data('digit') == number) {
    // We are already showing this number
    return false;
  }
  position.data('digit', number);
  var replacement = $('<div>', {
    'class': 'digit',
    css: {
      top: '-2.1em',
      opacity: 0
    },
    html: number
  });
  // The .static class is added when the animation
  // completes. This makes it run smoother.
  digit
    .before(replacement)
    .removeClass('static')
    .animate({ top: '2.5em', opacity: 0 }, 'fast', function () {
      digit.remove();
    })
  replacement
    .delay(100)
    .animate({ top: 0, opacity: 1 }, 'fast', function () {
      replacement.addClass('static');
    });
}
(function ($) {

  // количество секунд в каждом блоке времени
  var days = 24 * 60 * 60,
    hours = 60 * 60,
    minutes = 60;
  // создание плагина
  $.fn.countdown = function (prop) {
    var options = $.extend({
      callback: function () { },
      timestamp: 0
    }, prop);
    var left, d, h, m, s, positions;
    // Инициализация таймера
    init(this, options);
    positions = this.find('.position');
    (function tick() {
      // Оставьшееся время
      left = Math.floor((options.timestamp - (new Date())) / 1000);
      if (left < 0) {
        left = 0;
      }
      // Количество оставшихся дней
      d = Math.floor(left / days);
      updateDuo(0, 1, d);
      left -= d * days;
      // Количество оставшихся часов
      h = Math.floor(left / hours);
      updateDuo(2, 3, h);
      left -= h * hours;
      // Количество оставшихся минут
      m = Math.floor(left / minutes);
      updateDuo(4, 5, m);
      left -= m * minutes;
      // Количество оставшихся секунд
      s = left;
      updateDuo(6, 7, s);
      // Callback
      options.callback(d, h, m, s);
      // Автоматический вызов этой функции каждую секунду
      setTimeout(tick, 1000);
    })();
    // Эта функция обновляет две цифры в блоке
    function updateDuo(minor, major, value) {
      switchDigit(positions.eq(minor), Math.floor(value / 10));
      switchDigit(positions.eq(major), value);
    }
    return this;
  };
  /* Две вспомогательные функции, которые мы создали ранее */
})(jQuery);
$(function () {

  var note = $('#note'),
    ts = new Date(2019, 4, 5),
    newYear = true;
  if ((new Date()) > ts) {
    // The new year is here! Count towards something else.
    // Notice the *1000 at the end - time must be in milliseconds
    ts = (new Date()).getTime() + 24 * 60 * 60 * 1000;
    newYear = false;
  }
  $('#countdown').countdown({
    timestamp: ts,
    callback: function (days, hours, minutes, seconds) {
      var message = "";
      message += days + " day" + (days == 1 ? '' : 's') + ", ";
      message += hours + " hour" + (hours == 1 ? '' : 's') + ", ";
      message += minutes + " minute" + (minutes == 1 ? '' : 's') + " and ";
      message += seconds + " second" + (seconds == 1 ? '' : 's') + " <br />";
      if (newYear) {
        message += "left until the new year!";
      }
      else {
        message += "left to 10 days from now!";
      }
      note.html(message);
    }
  });
});

$(window).resize(function () {
  addBrandSlider();
});
addBrandSlider();

function addBrandSlider() {
  if (window.innerWidth < 567) {
    $(".brands-row").removeClass('row')
    $(".dist_items").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      centerMode: true,
      focusOnSelect: true
    });
  } else {
    $(".dist_items.slick-initialized").slick('unslick');
    $(".brands-row").addClass("row");
  }
}
$(window).resize(function () {
  addSponsorSlider();
});
addSponsorSlider();

function addSponsorSlider() {
  if (window.innerWidth < 567) {
    $(".gen-sponsor").removeClass('row')
    $(".item_sponsors").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      centerMode: true,
      focusOnSelect: true
    });
  } else {
    $(".item_sponsors.slick-initialized").slick('unslick');
    $(".gen-sponsor").addClass("row");
  }
}

$(window).resize(function () {
  addStockSlider();
});
addStockSlider();

function addStockSlider() {
  if (window.innerWidth < 567) {
    $(".prize_stock").removeClass('row')
    $(".right_column_prize").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      centerMode: true,
      infinite:false,
      focusOnSelect: true
    });
  } else {
    $(".right_column_prize.slick-initialized").slick('unslick');
    $(".prize_stock").addClass("row");
  }
}
$('.link_not_show').on('click', function(){
  $('.new_adress').toggle();
});
$('.info_pic_show').on('click', function(){
  $('.week_sells').toggle();
});
$('.btn_question').on('click', function(){
  $('.question_input').css("display" , "block");
  $('.text_question').css("display" , "none");
});